import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";
import { type ComponentProps } from "react";

function PrintIcon(props: ComponentProps<typeof SvgIcon>) {
  return (
    <SvgIcon {...props}>
      <g>
        <path
          // eslint-disable-next-line max-len
          d="m21.5 18h-3c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h3c.827 0 1.5-.673 1.5-1.5v-7c0-.827-.673-1.5-1.5-1.5h-19c-.827 0-1.5.673-1.5 1.5v7c0 .827.673 1.5 1.5 1.5h3c.276 0 .5.224.5.5s-.224.5-.5.5h-3c-1.379 0-2.5-1.122-2.5-2.5v-7c0-1.378 1.121-2.5 2.5-2.5h19c1.379 0 2.5 1.122 2.5 2.5v7c0 1.378-1.121 2.5-2.5 2.5z"
          data-original="#000000"
          data-old_color="#000000"
          fill="#FFFFFF"
        />
        <path
          d="m14.5 21h-6c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h6c.276 0 .5.224.5.5s-.224.5-.5.5z"
          data-original="#000000"
          data-old_color="#000000"
          fill="#FFFFFF"
        />
        <path
          d="m14.5 19h-6c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h6c.276 0 .5.224.5.5s-.224.5-.5.5z"
          data-original="#000000"
          data-old_color="#000000"
          fill="#FFFFFF"
        />
        <path
          d="m10.5 17h-2c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h2c.276 0 .5.224.5.5s-.224.5-.5.5z"
          data-original="#000000"
          data-old_color="#000000"
          fill="#FFFFFF"
        />
        <path
          // eslint-disable-next-line max-len
          d="m18.5 7c-.276 0-.5-.224-.5-.5v-4c0-.827-.673-1.5-1.5-1.5h-9c-.827 0-1.5.673-1.5 1.5v4c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-4c0-1.378 1.121-2.5 2.5-2.5h9c1.379 0 2.5 1.122 2.5 2.5v4c0 .276-.224.5-.5.5z"
          data-original="#000000"
          data-old_color="#000000"
          fill="#FFFFFF"
        />
        <path
          // eslint-disable-next-line max-len
          d="m16.5 24h-9c-1.379 0-2.5-1.122-2.5-2.5v-8c0-.276.224-.5.5-.5h13c.276 0 .5.224.5.5v8c0 1.378-1.121 2.5-2.5 2.5zm-10.5-10v7.5c0 .827.673 1.5 1.5 1.5h9c.827 0 1.5-.673 1.5-1.5v-7.5z"
          data-original="#000000"
          data-old_color="#000000"
          fill="#FFFFFF"
        />
      </g>
    </SvgIcon>
  );
}

export default PrintIcon;
